import { Injectable } from '@angular/core';
import { FuseNavigationItem } from '@fuse/components/navigation';
import { FuseMockApiService } from '@fuse/lib/mock-api';
import { compactNavigation, defaultNavigation, futuristicNavigation, horizontalNavigation } from 'app/mock-api/common/navigation/data';
import { cloneDeep } from 'lodash-es';
import { UserService } from 'app/core/user/user.service';
import { Subject, Observable } from 'rxjs';
import { map, takeUntil } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class NavigationMockApi {
    private readonly _compactNavigation: FuseNavigationItem[] = compactNavigation;
    private readonly _defaultNavigation: FuseNavigationItem[] = defaultNavigation;
    private readonly _futuristicNavigation: FuseNavigationItem[] = futuristicNavigation;
    private readonly _horizontalNavigation: FuseNavigationItem[] = horizontalNavigation;
    private _unsubscribeAll: Subject<any> = new Subject<any>();

    constructor(private _fuseMockApiService: FuseMockApiService, private _userService: UserService) {
        this.registerHandlers();
    }

    registerHandlers(): void {
        this._fuseMockApiService
            .onGet('api/common/navigation')
            .reply(() => {
                // Usa getCurrentUserRole y maneja los datos de forma reactiva
                return this.getCurrentUserRole().pipe(
                    map(userRoles => {
                        // Lógica para filtrar la navegación
                        const filteredNavigation = this._defaultNavigation.filter(navItem =>
                            !navItem.roles || navItem.roles.some(role => userRoles.includes(role))
                        );

                        // Rellenar la navegación con los datos filtrados
                        this.fillNavigationChildren(this._compactNavigation, filteredNavigation);
                        this.fillNavigationChildren(this._futuristicNavigation, filteredNavigation);
                        this.fillNavigationChildren(this._horizontalNavigation, filteredNavigation);

                        // Devuelve la respuesta
                        return [
                            200,
                            {
                                compact: cloneDeep(this._compactNavigation),
                                default: cloneDeep(filteredNavigation),
                                futuristic: cloneDeep(this._futuristicNavigation),
                                horizontal: cloneDeep(this._horizontalNavigation),
                            },
                        ];
                    })
                );
            });
    }

    private getCurrentUserRole(): Observable<string[]> {
        return this._userService.user$
            .pipe(
                takeUntil(this._unsubscribeAll),
                map((user: any) => Array.isArray(user.roles) ? user.roles.map(role => role.name) : [])
            );
    }

    private fillNavigationChildren(targetNavigation: FuseNavigationItem[], sourceNavigation: FuseNavigationItem[]): void {
        targetNavigation.forEach((targetNavItem) => {
            sourceNavigation.forEach((sourceNavItem) => {
                if (sourceNavItem.id === targetNavItem.id) {
                    targetNavItem.children = cloneDeep(sourceNavItem.children);
                }
            });
        });
    }
}
